module.exports = __webpack_public_path__ + "img/playbar_voice_1.dbb7b40d.svg";